<template>
  <div class="auditPublisher">
    <img
      src="../../assets/img/registerSuccess.png"
      alt="usemap"
      usemap="#lessons"
      width="100%"
      hidefocus="true"
    />
    <map name="lessons">
      <area
        shape="rect"
        :coords="coordsList[0]"
        v-clipboard:copy="copyUrl"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
      <area
        shape="rect"
        :coords="coordsList[1]"
        @click="jumpExternalLinks('https://a.app.qq.com/o/simple.jsp?pkgname=com.daogj.seller&channel=0002160650432d595942&fromcase=60001')"
        onfocus="blur(this);"
      >
      <area
        shape="rect"
        :coords="coordsList[2]"
        @click="dialPhone('0752-2162293')"
      >
    </map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyUrl: "https://pc.yamyamyam.com/",
      coordsList: []
    }
  },
  methods: {
    jumpExternalLinks(url) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = url;
      } else {
        window.Android.jumpExternalLinks(url);
      }
    },
    dialPhone(phone) {
      if (this.$store.getters.ambientType != 1) {
        window.location.href = 'tel:' + phone;
      } else {
        window.Android.dialPhone(phone);
      }
    },
    // px换算成rem
    pxHandle(px) {
      let clientWidth = document.documentElement.clientWidth;
      return Math.ceil(px * clientWidth / 375)
    },
    onCopy() {
      this.$toast("复制成功");
    },
    onError() {
      this.$toast("复制失败，请重试");
    },
  },
  created() {
    this.coordsList[0] = `${this.pxHandle(0)},${this.pxHandle(370)},${this.pxHandle(375)},${this.pxHandle(455)}`;
    this.coordsList[1] = `${this.pxHandle(0)},${this.pxHandle(480)},${this.pxHandle(375)},${this.pxHandle(570)}`;
    this.coordsList[2] = `${this.pxHandle(0)},${this.pxHandle(620)},${this.pxHandle(375)},${this.pxHandle(655)}`;
  }
}
</script>

<style lang="scss" scoped>
.auditPublisher {
  margin-top: -44px;
  img {
    display: block;
  }
  area {
  }
}
</style>